import { useEffect } from 'react';

import {
    INBOX_CONTAINER
} from '@interlayer/js/components/system/CommunicationWidgets/hooks/useInitWidgets/constants.buzz';

export const useStickyCommunication = (isTop: boolean) => {
    useEffect(() => {
        document.getElementById(INBOX_CONTAINER)?.classList[isTop ? 'add' : 'remove']('sticky');
        document.getElementById('chatContainer')?.classList[isTop ? 'add' : 'remove']('sticky');
    }, [isTop]);
};
